module.exports = __webpack_public_path__ + "assets/img/96c6e83f68e73e74a13c733b82728b6f.png";